var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvaluation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.75 10.375c0-.518.42-.937.938-.937h3.75a.937.937 0 1 1 0 1.874h-3.75a.937.937 0 0 1-.938-.937M5.688 5.688a.937.937 0 1 0 0 1.875h7.5a.937.937 0 1 0 0-1.875zM4.75 17.875c0-.518.42-.937.938-.937h3.75a.937.937 0 1 1 0 1.875h-3.75a.937.937 0 0 1-.938-.938M5.688 13.188a.937.937 0 1 0 0 1.874h7.5a.937.937 0 1 0 0-1.874z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M1 3.813A2.813 2.813 0 0 1 3.813 1h16.875A2.813 2.813 0 0 1 23.5 3.813v3.79l-1.875 1.874V3.813a.937.937 0 0 0-.937-.938H3.813a.937.937 0 0 0-.938.938v24.375c0 .517.42.937.938.937h16.875c.517 0 .937-.42.937-.937v-9.415l1.875-1.875v11.29A2.813 2.813 0 0 1 20.688 31H3.813A2.813 2.813 0 0 1 1 28.188z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m11.652 22.409 1.69 1.689 1.636-.727L29.013 9.336a1.837 1.837 0 0 0-2.599-2.599l-1.299 1.3 1.662 1.661-1.025 1.025L24.09 9.06 12.38 20.772zM25.39 5.713a3.286 3.286 0 1 1 4.647 4.647L15.955 24.443q-.143.142-.327.224l-5.6 2.489a1.086 1.086 0 0 1-1.434-1.435l2.489-5.599q.082-.185.224-.327z"
})));
export default SvgEvaluation;